import { InfectopharmRole } from "../../__generated__/SupplyEfnForm_UserFragment.graphql";

export const isTargetRoleWithSpeciality = (targetRole: InfectopharmRole = "Other") => {
	return (
		targetRole === "Doctor" ||
		targetRole === "Apothecary" ||
		targetRole === "AlliedHealthProfessionals"
	);
};
